import { DEFAULT_VIEW_PREFS } from '../default-prefs';

class DefaultPreferenceService {

  constructor () {
    if(DefaultPreferenceService.instance) {
      return DefaultPreferenceService.instance;
    }

    DefaultPreferenceService.instance = this;
  }

  getDefaultViewPreferences (viewId) {
    return DEFAULT_VIEW_PREFS[viewId];
  }

}


const instance = new DefaultPreferenceService();
Object.freeze(instance);

export default instance;
